{
  "actionbar.actions": "Handlinger",
  "actionbar.actionsAvailable": "Tilgjengelige handlinger.",
  "actionbar.clearSelection": "Tøm utvalg",
  "actionbar.selected": "Valde element: {count}",
  "actionbar.selectedAll": "Alle er valgt",
  "actionbutton.pending": "avventer",
  "breadcrumbs.more": "Flere elementer",
  "button.pending": "avventer",
  "calendar.invalidSelection": "Valgt(e) {selectedCount, plural, one {dato} other {datoer}} er utilgjengelig.",
  "combobox.loading": "Laster inn...",
  "combobox.loadingMore": "Laster inn flere...",
  "combobox.noResults": "Ingen resultater",
  "contextualhelp.help": "Hjelp",
  "contextualhelp.info": "Informasjon",
  "datepicker.endTime": "Sluttid",
  "datepicker.startTime": "Starttid",
  "datepicker.time": "Tid",
  "dialog.alert": "Varsel",
  "dialog.dismiss": "Lukk",
  "dropzone.replaceMessage": "Slipp filen for å erstatte",
  "inlinealert.informative": "Informasjon",
  "inlinealert.negative": "Feil",
  "inlinealert.notice": "Advarsel",
  "inlinealert.positive": "Vellykket",
  "label.(optional)": "(valgfritt)",
  "label.(required)": "(obligatorisk)",
  "listview.loading": "Laster inn...",
  "listview.loadingMore": "Laster inn flere...",
  "menu.loading": "Laster inn...",
  "menu.loadingMore": "Laster inn flere...",
  "menu.moreActions": "Flere handlinger",
  "menu.noResults": "Ingen resultater",
  "menu.unavailable": "Utilgjengelig, utvid for detaljer",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Laster inn...",
  "picker.loadingMore": "Laster inn flere...",
  "picker.placeholder": "Velg …",
  "picker.selectedCount": "{count, plural, =0 {Ingen elementer er valgt} one {# element er valgt} other {# elementer er valgt}}",
  "sidepanel.collapse": "Skjul sidepanelet",
  "sidepanel.expand": "Vis sidepanelet",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.cancel": "Avbryt",
  "table.drag": "Dra",
  "table.editCell": "Rediger celle",
  "table.loading": "Laster inn...",
  "table.loadingMore": "Laster inn flere...",
  "table.resizeColumn": "Endre størrelse på kolonne",
  "table.save": "Lagre",
  "table.sortAscending": "Sorter stigende",
  "table.sortDescending": "Sorter synkende",
  "tag.actions": "Handlinger",
  "tag.hideButtonLabel": "Vis mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Vis alle ({tagCount, number})",
  "toast.clearAll": "Fjern alle",
  "toast.collapse": "Skjul",
  "toast.showAll": "Vis alle",
  "treeview.loadingMore": "Laster inn flere..."
}
